export default class Ordinance {
  constructor({ data, title, t }) {
    this.data = data || {}
    this.t = t

    this.appendNotAvailableIfNotComplete()
    this.appendTitle(title)
  }

  isNotEmpty = (data) => Object.keys(data).length > 0

  buildIncompleteOrdinance = () => ({
    incomplete: this.t('wcf.PersonOrdinances.incomplete', 'Incomplete'),
  })

  appendTitle = (title) => {
    this.data.name = title
  }

  appendNotAvailableIfNotComplete = () => {
    if (!this.isConsideredComplete()) {
      this.data.unknown = this.t('wcf.person-ordinances.notAvailable', 'Not Available')
    }
  }

  isConsideredComplete = () => {
    if (this.data.completedDate || this.data.completedPlace || this.data.status === 'BORN_IN_COVENANT') {
      return true
    }
    return false
  }
}
